import { useNavigate, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Ana Sayfa', path: '/', sectionId: 'ana-sayfa' },
  { label: 'Hakkımızda', path: '/hakkimizda', sectionId: 'hakkimizda' },
  { label: 'Hizmetler', path: '/hizmetler', sectionId: 'hizmetler' },
  { label: 'Hedef Ülkeler', path: '/hedef-ulkeler', sectionId: 'hedef-ulkeler' },
  { label: 'Galeri', path: '/galeri', sectionId: 'galeri' },
  { label: 'İletişim', path: '/iletisim', sectionId: 'iletisim' },
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const handleClick = (item: typeof navItems[0]) => {
    if (isHome) {
      const el = document.getElementById(item.sectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate(item.path);
      }
    } else {
      navigate(item.path);
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">

          {/* Col 1: Brand */}
          <div>
            <img
              src="/assets/images/logo.png"
              alt="Global79 Lojistik"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Kilis merkezli Global79 Lojistik olarak yurtiçi, yurtdışı ve uluslararası güvenli ve hızlı taşımacılık hizmeti sunuyoruz.
            </p>
            <div className="flex items-center gap-3">
              {['ri-facebook-fill', 'ri-instagram-line', 'ri-linkedin-fill', 'ri-whatsapp-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-orange-500 rounded-full transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-white text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Col 2: Nav Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              Sayfalar
              <div className="w-8 h-0.5 bg-orange-500 mt-2" />
            </h4>
            <ul className="flex flex-col gap-3">
              {navItems.map((item) => (
                <li key={item.path}>
                  <a
                    href={item.path}
                    onClick={(e) => { e.preventDefault(); handleClick(item); }}
                    className="flex items-center gap-2 text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer group"
                  >
                    <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              İletişim
              <div className="w-8 h-0.5 bg-orange-500 mt-2" />
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-500/20 rounded-lg flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-orange-400 text-sm" />
                </div>
                <span className="text-gray-400 text-sm leading-relaxed">
                  Mehmet Abdi Bulut Mh. Fatma Şahin Cd. No:10<br />Merkez / Kilis
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-500/20 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-orange-400 text-sm" />
                </div>
                <a href="tel:05382323822" className="text-gray-400 hover:text-orange-400 text-sm transition-colors">
                  0 538 232 38 22
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-emerald-500/20 rounded-lg flex-shrink-0">
                  <i className="ri-whatsapp-line text-emerald-400 text-sm" />
                </div>
                <a
                  href="https://wa.me/905382323822?text=Merhaba%2C%20lojistik%20hizmetleriniz%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  WhatsApp ile Ulaş
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="text-2xl font-extrabold text-white tracking-tight">GLOBAL79</span>
            <span className="text-gray-400 font-light text-sm">LOJİSTİK</span>
            <span className="text-gray-600 text-xs ml-2">— Güvenle Taşıyoruz</span>
          </div>
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} Global79 Lojistik. Tüm hakları saklıdır.
          </p>
        </div>
        <a
          href="https://epiked.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 pt-5 border-t border-white/10 flex items-center justify-center gap-3 text-gray-300 text-sm hover:text-white transition-colors"
        >
          <img
            src="/assets/images/elogo.avif"
            alt="Epiked Logo"
            className="h-6 w-auto object-contain"
          />
          <span>Profesyonel web sistemleri ile hazırlanmıştır.</span>
        </a>
      </div>
    </footer>
  );
}
